module.exports = __webpack_public_path__ + "img/logo-white.9d37d72d.png";